export default __webpack_public_path__ + "6b05d18ef56dc37cb4d4e0487bf973c8.png";